import { Card, CardContent, Grid, Typography } from "@mui/material";
import { Timestamp } from "firebase/firestore";
import { useRecordContext } from "react-admin";

interface UserAction {
  referenceId: string;
  referenceType: string;
  userId: string;
  userName: string;
  social: string;
  email: string;
  count: number;
  time: Timestamp;
}

const LikeShow = () => {
  const record = useRecordContext<UserAction>();
  if (!record) return null;

  return (
    <Card sx={{ width: 600, margin: "auto" }}>
      <CardContent>
        {/* Details */}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body1">
              <strong>Name:</strong> {record.userName}
            </Typography>
            <Typography variant="body1">
              <strong>Social:</strong> {record.social}
            </Typography>
            <Typography variant="body1">
              <strong>Email:</strong> {record.email}
            </Typography>

            <Typography variant="body1">
              <strong>User ID:</strong> {record.userId}
            </Typography>
            <Typography variant="body1">
              <strong>Reference Type:</strong> {record.referenceType}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">
              <strong>Reference ID:</strong> {record.referenceId}
            </Typography>
            <Typography variant="body1">
              <strong>Time:</strong>{" "}
              {record.time.toDate().toLocaleString()}
            </Typography>
            <Typography variant="body1">
              <strong>Count:</strong> {record.count}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default LikeShow;
